<template lang="pug">
.team-container
  h2.title(:class="$mq") La Team
  .team-content(:class="$mq")
    .member
      img.picture(src="@/assets/img/ludovic_square.jpg" alt="Ludovic")
      h3.name(:class="$mq") Ludovic
      h4.role(:class="$mq") CEO, CTO & Co&#8209;Founder
      .quote(:class="$mq") "Je développe l'application pour qu'elle soit belle, moderne et rapide."
    .member
      img.picture(src="@/assets/img/sandrine_square.jpg" alt="Sandrine")
      h3.name(:class="$mq") Sandrine
      h4.role(:class="$mq") COO, CFO, Product Manager & Co&#8209;Founder
      .quote(:class="$mq") "Je pense et réfléchis l'appli pour qu'elle soit pratique et permette d'apprendre la symptothermie moderne facilement."
</template>

<script>
export default {
  name: 'Team'
}
</script>

<style lang="scss" scoped>
@use '@/styles/text';
@use '@/styles/colors';

.title {
  @include text.title;
}

.team-content {
  display: grid;
  justify-content: center;
  justify-items: center;
  column-gap: 8%;
  row-gap: 100px;

  &.phone,
  &.tablet-portrait {
    grid-template-columns: 75%;
    grid-template-rows: repeat(2, auto);
    .member {
      grid-template-rows: 260px 30px 40px auto;
    }
  }

  &.tablet-landscape {
    grid-template-columns: repeat(2, 400px);
  }
  &.desktop,
  &.large-desktop {
    grid-template-columns: repeat(2, 500px);
  }

  .member {
    display: grid;
    justify-items: center;
    grid-template-rows: 275px 50px 40px auto;
    row-gap: 30px;
    width: 100%;
    .picture {
      max-width: 100%;
      width: 250px;
      height: auto;
      // background-color: $light-purple-gradient;
      border-radius: 150px;
    }

    .name {
      @include text.subtitle;
    }

    .role {
      @include text.normal;
      color: colors.$intense-purple-gradient;
    }

    .quote {
      @include text.normal;
      width: 400px;

      &.phone {
        width: auto;
      }
      font-style: italic;
      font-weight: 300;
    }
  }
}
</style>
